import { useState } from "react";
import moment from "moment-timezone";
import _ from "underscore";
import GQLUtil from "./gqlHelper";
import { submitCaseSuccess } from "../../components/Form/actions";

const containsOnlyNumbers = (str) => /^\d+$/.test(str);
const isBadNaics = (code, desc) => {
  return (
    (!!code && code.toString().length < 4) || // Code is invalid length
    (!!code && !desc) || // Code is present but description is null
    (!code && !!desc) || // Description is present but code is null
    (!!desc && containsOnlyNumbers(desc)) || // Description holds code
    (!!code && !containsOnlyNumbers(code))
  ); // Code holds description or is corrupted
};
//helper object;
const util = {
  isLocalhost: () => {
    return window.location.hostname === "localhost";
  },
  getCurrentHost: () => {
    return window.location.origin;
  },

  getGqlApiUrl: () => {
    return window.location.hostname === "localhost"
      ? "http://localhost:9393/auth/graphql"
      : `${window.location.origin}/auth/auth/graphql`;
  },

  buildFullUrl: (url) => {
    return window.location.hostname === "localhost"
      ? `http://localhost:9393` + url
      : `${window.location.origin}/auth` + url;
  },

  joinClassNames: function () {
    // takes args with classnames and returns them with spaces in between
    var classes = [].slice.call(arguments);
    return classes.join(" ");
  },

  // Escapes Double Quotes if it's not already escaped:
  cleanGraphqlParamater: function (arg) {
    const cleanedParamater = arg
      .replace(/\\([\s\S])|(")/g, "\\$1$2")
      .replace(/\n/g, "\\n");
    return cleanedParamater;
  },

  //TODO: move this over to the gqlHelper and revisit the notification dispatch here
  handleGraphql: async (query, payLoaddata) => {
    // console.log(query);
    let apiIndex = util.isLocalhost()
      ? "http://localhost:9393/auth/graphql"
      : `${util.getCurrentHost()}/auth/auth/graphql`;
    const opts = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query }),
    };

    const data = await fetch(apiIndex, opts)
      .then((res) => {
        // console.log(res);
        return res.json();
      })
      .then((data) => {
        // console.log(data);
        submitCaseSuccess(payLoaddata);
        return data;
      });

    return data;
  },

  parseObjectForGraphql: (obj) => {
    let graphqlstr = "";
    Object.keys(obj).forEach((x) => {
      if (obj[x] !== null) {
        graphqlstr += `${x}: "${obj[x]}",`;
      }
    });
    return graphqlstr;
  },

  convertFileSize: function (bytes, si, un = false) {
    var thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
      return bytes + " B";
    }
    var units = si
      ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
    var u = -1;
    do {
      bytes /= thresh;
      ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);

    if (!un) {
      return bytes.toFixed(1);
    }

    return bytes.toFixed(1) + " " + units[u];
  },

  isValidFile: function (file, mime_types, file_size = 31457280) {
    if (!this.checkAzureRules(file.name) || !this.checkCharCode(file.name)) {
      return false;
    }
    return mime_types.indexOf(file.type) !== -1 && file.size <= file_size;
  },

  checkAzureRules: function (file) {
    if (
      file.indexOf("/") !== -1 ||
      file.indexOf(":") !== -1 ||
      file[file.length - 1] === "."
    ) {
      return false;
    }
    return true;
  },
  badCharacter: function (char) {
    const charCode = char.charCodeAt(0);
    return (
      charCode <= 8 ||
      (charCode >= 11 && charCode <= 12) ||
      (charCode >= 14 && charCode <= 31) ||
      // High Private Use Surrogates
      (charCode >= 55296 && charCode <= 57343) ||
      // Private Use Area
      (charCode >= 61474 && charCode <= 63743) ||
      (charCode >= 65533 && charCode <= 65535) ||
      // Supplemental Private Use Area
      charCode >= 1114112
    );
  },
  badFileCharacter: function (char) {
    return (
      this.badCharacter(char) ||
      [
        34, 42, 43, 47, 58, 60, 62, 63, 92, 124, 162, 174, 209, 239, 8211, 8364,
      ].includes(char.charCodeAt(0))
    );
  },
  removeBadChars: function (str) {
    if (typeof str === "string" || str instanceof String) {
      return [...str].filter((s) => !this.badCharacter(s)).join("");
    } else {
      return str;
    }
  },
  checkCharCode: function (str) {
    for (var i = 0; i < str.length; i++) {
      if (this.badFileCharacter(str[i])) {
        return false;
      }
    }
    return true;
  },
  isBadNaics: (code, desc) => {
    return (
      (!!code && code.toString().length < 4) || // Code is invalid length
      (!!code && !desc) || // Code is present but description is null
      (!code && !!desc) || // Description is present but code is null
      (!!desc && containsOnlyNumbers(desc)) || // Description holds code
      (!!code && !containsOnlyNumbers(code))
    ); // Code holds description or is corrupted
  },
  setBadNaics: (formId, dataToMap, fieldName, value) => {
    const naicsFieldMapping = {
      "9142B": ["empNaics", "empNaicsDesc"],
      9089: ["empNaics", "empNaicsDesc"],
      "9142A": ["eta_790_b16_poc_naics", "eta_790_b16_poc_naics_description"],
      "9142C": ["empNaics", "empNaicsDesc"],
      employer: ["new_profile_emp_naics", "new_profile_emp_naics_description"],
    };
    const naicsFields = naicsFieldMapping[formId];
    const naicsCode = dataToMap[naicsFields[0]];
    const naicsDesc = dataToMap[naicsFields[1]];
    if (naicsFields.includes(fieldName) && isBadNaics(naicsCode, naicsDesc)) {
      return null;
    }
    return value;
  },
  _mapKeys: function (obj, newKeys) {
    const keyValues = Object.keys(obj).map((key) => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  },

  _filterByKeys: function (caseToPullfrom, allowed) {
    return Object.keys(caseToPullfrom)
      .filter((key) => allowed.includes(key))
      .reduce((obj, key) => {
        obj[key] = caseToPullfrom[key];
        return obj;
      }, {});
  },

  isDisabled: function (available_date, roles) {
    const now = moment.tz(new Date(), "America/New_York");
    let goLive = moment.tz(available_date, "America/New_York");

    var checkRole = _.filter(roles, function (value) {
      return value.roleName === "developer" || value.roleName === "tester";
    });
    if (checkRole && checkRole.length > 0) {
      return false;
    } else if (now.isAfter(goLive)) {
      return false;
    }
    return true;
  },

  isTester: function (roles) {
    let isTester = false;
    roles.forEach((x) => {
      if (x.roleName === "developer" || x.roleName === "tester") {
        isTester = true;
      }
    });
    return isTester;
  },

  toTitleCase: function (str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },

  getGtagId: function () {
    const GA_TRACKING_ID_TEST = "G-2EVWV9LQDN";
    const GA_TRACKING_ID_STAGING = "G-L5342HN749";
    const GA_TRACKING_ID_PRODUCTION = "G-D45X89LR1D";

    if (window.location.hostname === "test.flag.dol.gov") {
      return GA_TRACKING_ID_TEST;
    } else if (window.location.hostname === "staging.flag.dol.gov") {
      return GA_TRACKING_ID_STAGING;
    } else if (window.location.hostname === "flag.dol.gov") {
      return GA_TRACKING_ID_PRODUCTION;
    } else {
      return GA_TRACKING_ID_TEST;
    }
  },
  reCaptchaKey: function () {
    const RECAPTCHA_V3_LOCAL_DEV_TEST_STAGING =
      "6LcninIqAAAAAJ4JyPswQGS821pORvauXZ4G4PDW";
    const RECAPTCHA_V3_PROD = "6LfrKFgqAAAAANQLsoQ9pFll2U-HuLjG57Qq-LFI";

    if (window.location.hostname === "flag.dol.gov") {
      return RECAPTCHA_V3_PROD;
    } else {
      return RECAPTCHA_V3_LOCAL_DEV_TEST_STAGING;
    }
  },

  countyIndex: function () {
    if (window.location.hostname === "localhost") {
      return process.env.REACT_APP_AZURE_COUNTY_LOCAL;
    } else if (window.location.hostname === "dev.flag.dol.gov") {
      return process.env.REACT_APP_AZURE_COUNTY_DEV;
    } else if (window.location.hostname === "test.flag.dol.gov") {
      return process.env.REACT_APP_AZURE_COUNTY_TEST;
    } else if (window.location.hostname === "staging.flag.dol.gov") {
      return process.env.REACT_APP_AZURE_COUNTY_STAGING;
    } else if (window.location.hostname === "flag.dol.gov") {
      return process.env.REACT_APP_AZURE_COUNTY_PRODUCTION;
    } else {
      console.log("Location hostname unrecognized, using prod by default.");
      return process.env.REACT_APP_AZURE_COUNTY_PRODUCTION;
    }
  },
  naicsIndex: function () {
    const naicsProxy =
      "foreign-labor/naics/docs/suggest?api-version=2020-06-30";
    const apiIndex = this.isLocalhost()
      ? `https://dev.flag.dol.gov/${naicsProxy}`
      : `${this.getCurrentHost()}/${naicsProxy}`;
    return apiIndex;
  },
  socIndex: function () {
    const socProxy = "foreign-labor/soc/docs/suggest?api-version=2020-06-30";
    const apiIndex = this.isLocalhost()
      ? `https://dev.flag.dol.gov/${socProxy}`
      : `${this.getCurrentHost()}/${socProxy}`;
    return apiIndex;
  },
  useFunctionAsState: function (fn) {
    const [val, setVal] = useState(() => fn);
    function setFunc(fn) {
      setVal(() => fn);
    }
    return [val, setFunc];
  },
  useReactTable: function (initialState) {
    // console.log(initialState)
    // const [ type, setType ] = useState(initialState.type)
    // const [ limit, setLimit ] = useState(initialState.limit)
    // const [ page, setPage ] = useState(initialState.page)
    // const [ sort_ascending, setSort_ascending ] = useState(initialState.sort_ascending)
    // const [ sort_column, setSort_column] = useState(initialState.sort_column)
    const [UISorting, setUISorting] = useState(initialState);

    function updateUISorting(args) {
      const newUI = { ...UISorting, ...args };
      setUISorting(newUI);
    }

    return [UISorting, updateUISorting];
    // return [ type, setType, limit, setLimit, page, setPage, sort_ascending, setSort_ascending, sort_column, setSort_column ]
  },
  fileExists: async function (app_id, file_name) {
    let res = await GQLUtil.genericGQLQuery(`query {
        fileExists(
          app_id: "${app_id}",
          document_name: "${file_name}"
        ) 
      }`);
    if (res.data.fileExists) {
      return res.data.fileExists;
    } else {
      return false;
    }
  },
  isUserErrorMessage: (result) => {
    return (
      !!result.errors?.[0]?.message &&
      result.errors?.[0]?.extensions.type === "UserErrorMessage"
    );
  },
  toUSD: (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  },
  parseUSD: (usdString) => {
    if (!usdString || typeof usdString !== "string") return NaN;

    // Remove anything that's not a digit, period, minus sign
    const cleaned = usdString.replace(/[^0-9.-]+/g, "");

    return parseFloat(cleaned);
  },
};

export default util;
